import { createContext } from "react";

export const WarehousesDocsContext = createContext(null);
